var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',{class:{'no-data-img':true,'info-no-data-img':_vm.infoNoData}}),_vm._t("default",function(){return [_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.desc))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }